export default {
  App: {
    userTypes: {
      buyer: 'Home Buyer',
      loanOfficer: 'Loan Officer',
      realEstateAgent: 'Real Estate Agent',
      admin: 'Administrator',
    },
    BidRequest: {
      loanAmmount: 'Loan Amount',
      ltv: 'LTV',
      city: 'City',
      homeValue: 'Home Value',
      mortgageLoanAmount: 'Mortgage Loan Amount',
      targetLtv: 'Target LTV',
      preferredTermYears: 'Preferred Term (Years)',
      cashOutAmount: 'Cash Out Amount',
      buyerName: 'Mortgage Shopper',
      location: 'Location',
      military: 'Military',
      phone: 'Phone Number',
      email: 'Email',
      firstTime: 'First Time',
      requestDate: 'Request Date',
      realtor: 'Real Estate Agent',
      lockPeriod: 'Lock Period',
      creditScoreEstimate: 'Credit Score Estimate',
      annualPreTaxIncome: 'Annual Pre-tax Income',
      monthlyDebtPayment: 'Monthly Debt Payments',
      dtiEstimate: 'DTI Estimate',
      purpose: 'Purpose',
      occupancy: 'Occupancy',
      propertyType: 'Property type',
      hadBankrupt: 'Bankrupt in last 7 years',
      hadForeclosure: 'Foreclosure in last 7 years',
      foundHome: 'Found home',
    },
    Chat: {
      away: 'away',
    },
    bid: {
      totalCost: 'Total 5 yrs. Cost',
      interestRate: 'Interest Rate',
      apr: 'APR',
      payment: 'Mon. Payment',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en/models.js